

export class FileInfoImplementation {
  public http: any;
  public route: any;
  public enableButton:boolean = false;
  customMetadata: any;
  loggerService: any;
  public universalService: any;
  public selectedObjectData:any;
  fileInfoCommentsData:[] = [];
  fileInfoActivityData:[] = [];
  isDataOfScrollLoaded:boolean = false;
  defaultPageLimit:any = 100; //100 is default set on server side
  isNextPageAvailable:boolean = false;
  currentTimeToUse:any;
  noActivityEventLabel: any = "NO_ACTIVITY_BEFORE_SHARE";
  activityNextLink:any = "";
  static singleInstance:any = null;
  localStorageService:any;

  constructor(globalService) {
    this.setHandler(globalService)
  }

  public static getInstance(globalService):FileInfoImplementation{
    if(this.singleInstance == null){
      this.singleInstance = new FileInfoImplementation(globalService);
      return this.singleInstance;
    }else{
      return this.singleInstance;
    }
  }

  public setHandler(globalService) {
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
  }

  getFileInfoComments(url) {
    var self = this;
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        response => {
          resolve(response)
        },
        err => {
          self.loggerService.log("error in getting comments list", err);
          reject(err);
        }
      )
    });
  }

  addFileInfoComment(url,commentData){
    var self = this;
    var params = {
      "comment" : commentData
    }
    return new Promise(async function (resolve, reject) {
      self.http.post(url, params).subscribe(
        suc => {
          resolve(suc)
        },
        err => {
          reject(err);
        }
      )
    })
  }

  deleteFileInfoComment(url, commentKey){
    var params = {
      commentKey: commentKey
    }
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.put(url,params).subscribe(
          suc=>{
              self.loggerService.log("comment deleted successfully",suc);
              resolve("SUCCESS")
          },
          err=>{
              self.loggerService.log("error in delete comment",err);
              reject(err);
          }
      )
    })
  }

  getFileInfoActivity(url) {
    var self = this;
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        response => {
          resolve(response)
        },
        err => {
          self.loggerService.log("error in getting activity list", err);
          reject(err);
        }
      )
    });
  }

  toggleSmallLoader(state){
    if(state) {
      jQuery(".spinner_loader").show();
    } else {
      jQuery(".spinner_loader").hide();
    }
  }
}